import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Header,
  Grid,
  Breadcrumb,
  Icon,
  ModalActions,
} from "semantic-ui-react";
import { Checkbox, Select } from "antd";
import Tabs from "./Tabs/Tabs";

import axios from "axios";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";

const { Option } = Select;
const filtrarPorArea = [
  {
    key: 1,
    value: 1,
    text: "Adquisición de equipos y herramientas tecnológicas",
  },
  {
    key: 2,
    value: 2,
    text: "Apoyo para la participación en ferias y eventos del sector",
  },
  {
    key: 3,
    value: 3,
    text: "Áreas integradas",
  },
  { key: 4, value: 4, text: "Arte" },
];
const filtrarPorEstado = [
  {
    key: 1,
    value: 1,
    text: "Aprobado",
  },
  {
    key: 2,
    value: 2,
    text: "Reprobado",
  },
  { key: 3, value: 3, text: "Sin verificar" },
];
const cantidadRegistros = [
  {
    key: 1,
    value: 10,
    text: "10",
  },
  {
    key: 2,
    value: 20,
    text: "20",
  },
  { key: 3, value: 50, text: "50" },
  { key: 4, value: 100, text: "100" },
];
const initialState = {
  datossinfiltro: [],
};

export const GestionarPostulacionesJurados = () => {
  // State filtro de Estado
  const [statusInputvalue, setStatusInputvalue] = useState("");
  const [inputValue, setInputValue] = useState({});
  // fake state para switchear entre usuario evaluador y usuario admin
  const [userPermissions, setUserPermissions] = useState(true);
  const [loading, setLoading] = useState(false);
  const [filtroStado, setFiltroStado] = useState();
  const [principalState, setPrincipalState] = React.useState(initialState);
  const [paginacionTotal, setPaginacionTotal] = React.useState(0);
  const [cantidadPáginas, setCantidadPáginas] = React.useState(10);
  const [jurados, setJurados] = useState([]);

  const filterByMany = async (url: string) => {
    const response = await axios.get(url);

    if (response.data.juries) {
      setPrincipalState({ datossinfiltro: response.data.juries });
      setJurados(response.data.juries);
      setLoading(false);
      let x = response.data.juries.length / cantidadPáginas;
      x = Math.ceil(x);
      return setPaginacionTotal(x);
    }
  };

  const selectFilterEstado = async () => {
    const token = localStorage.getItem('token');

    let response = await axios.get(
      `${process.env.REACT_APP_SERVER_JURA2}juries/filter/status/?status=${selectFilter}`,
      {
        headers: {
          'Authorization': token
        }
      }
    );
    //console.log(response)
  };

  const selectFilter = async (e: any) => {
    /* const newValue = e.currentTarget.value; */
    //localhost:3333/api/juries/filter/status/?status=3
    const token = localStorage.getItem('token');

    let response = await axios.get(
      `${process.env.REACT_APP_SERVER_JURA2}juries/filter/status/?status=${e}`, 
      {
        headers: {
          'Authorization': token
        }
      }
    );
    if (response.data.juries) {
      //
      setPrincipalState({ datossinfiltro: response.data.juries });
      let copy = response.data.juries.map((data: any) => data);
      setJurados(response.data.juries);
      setLoading(false);
      let x = response.data.juries.length / cantidadPáginas;
      x = Math.ceil(x);
      return setPaginacionTotal(x);
    }
  };

  const inputFilter = async (e: any) => {
    const token = localStorage.getItem('token');

    let response = await axios.get(
      `${process.env.REACT_APP_SERVER_JURA2}juries/filter/code-word/?code_word=${e.target.value}`,
      {
        headers: {
          'Authorization': token
        }
      }
    );
    if (response.data.juries) {
      //
      setPrincipalState({ datossinfiltro: response.data.juries });
      let copy = response.data.juries.map((data: any) => data);
      setJurados(response.data.juries);
      setLoading(false);
      let x = response.data.juries.length / cantidadPáginas;
      x = Math.ceil(x);
      return setPaginacionTotal(x);
    }

    let datos: React.SetStateAction<any[]> = [];

    setJurados(datos);
    setPrincipalState({ datossinfiltro: datos });
    let x = 1;
    x = Math.ceil(x);
    setPaginacionTotal(x);
    console.log(e.target.value);
  };

  const primeroDatostabla = async () => {
    const token = localStorage.getItem('token');
    
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_SERVER_JURA2}juries/`,
        {
          headers: {
            'Authorization': token
          }
        }
      );
      //console.log(response.data);
      if (response.data.juries) {
        //
        setPrincipalState({ datossinfiltro: response.data.juries });
        let copy = response.data.juries.map((data: any) => data);
        setJurados(response.data.juries);
        setLoading(false);
        let x = response.data.juries.length / cantidadPáginas;
        x = Math.ceil(x);
        return setPaginacionTotal(x);
      }

      let datos: React.SetStateAction<any[]> = [];
      setJurados(datos);
      setPrincipalState({ datossinfiltro: datos });
      let x = 1;
      x = Math.ceil(x);
      return setPaginacionTotal(x);
    } catch (error) {
      return console.error(error);
    }
  };

  useEffect(() => {
    primeroDatostabla();
    selectFilterEstado();
  }, []);
  //console.log(jurados);
  return (
    <div className="h-100">
      {/* Componente de breadcrumb */}
      <Grid className="no-margin">
        <Grid.Column
          className="background-color-101c31 no-margin no-padding-top no-padding-bottom"
          style={{ padding: "4px 0" }}
        >
          <Breadcrumb style={{ paddingLeft: "4%" }}>
            <Breadcrumb.Section>
              <Icon name="home" className="font-color-FFFFFF" size="small" />
            </Breadcrumb.Section>
            <Breadcrumb.Divider className="font-color-FFFFFF font-size-8px">
              /
            </Breadcrumb.Divider>
            <Breadcrumb.Section className="font-family-Montserrat-Regular font-color-FFFFFF font-size-8px">
              Jurados
            </Breadcrumb.Section>
            <Breadcrumb.Divider className="font-color-FFFFFF font-size-8px">
              /
            </Breadcrumb.Divider>
            <Breadcrumb.Section className="font-family-Montserrat-Regular font-color-FFFFFF font-size-8px">
              Banco de jurados
            </Breadcrumb.Section>
          </Breadcrumb>
        </Grid.Column>
      </Grid>
      {/* Header */}
      <Grid style={{ backgroundColor: "#fff" }} className="no-margin">
        <Grid.Column>
          <Header as="h3" style={{ padding: "0 10px", display: "flex" }}>
            <div style={{ width: "450px" }}>
              Gestionar postulación de jurados
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div
                style={{
                  padding: "0 10px",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <Checkbox onChange={() => setUserPermissions(!userPermissions)}>
                  {userPermissions ? (
                    <span>Administrador</span>
                  ) : (
                    <span>Evaluador</span>
                  )}
                </Checkbox>
              </div>
            </div>
            <Header></Header>
          </Header>
        </Grid.Column>
      </Grid>
      <Tabs
        Tabla={jurados}
        setJurados={setJurados}
        primeroDatostabla={primeroDatostabla}
        selectFilter={selectFilter}
        inputFilter={inputFilter}
        userPermissions={userPermissions}
        filterByMany={filterByMany}
      />
    </div>
  );
};

GestionarPostulacionesJurados.propTypes = {};
